import { Component, OnInit } from '@angular/core';
import { TimesheetApprovalsService } from '../timesheet-approvals.service';
import { Router } from '@angular/router';
import { TimesheetEntryService } from '../../../employee/timesheet-entry/timesheet-entry.service';
import { ProjectDetails, TaskDetails } from '../../../employee/employee.interface';
import { DatePipe, Location } from '@angular/common';
import { MatSnackBar, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { RejectionConfirmationDialogComponent } from '../rejection-confirmation-dialog/rejection-confirmation-dialog.component';
import { DateDisplay } from '../../../employee/timesheet-entry/timesheet.interface';
import { SessionStorage } from 'ngx-webstorage';

@Component({
  selector: 'app-pendingtimesheet-details',
  templateUrl: './pendingtimesheet-details.component.html',
  styleUrls: ['./pendingtimesheet-details.component.css']
})
export class PendingtimesheetDetailsComponent implements OnInit {
  @SessionStorage() public user;
  @SessionStorage() public config;
  public selectedrowdetails: any;
  public firstDay: any;
  public lastDay: any;
  public firstDayDate: any;
  public lastDayDate: any;
  public yearFirst: any;
  public yearLast: any;
  public currentDate: any;
  public currentYear: any;
  public projects: ProjectDetails[] = [];
  public weekNumer: any;
  public currentWeek: any;
  public dateWeak: any;
  public openLeave: Boolean = false;
  public tasktypeList: any = [];
  public projecttypeList: any = [];
  public data: any;
  public userDetails: any;
  public status: any;
  public rejectionComments: string;
  public dateDisplay: Array<any> = [];
  public dayTotal = [];
  public weakTotal = '00:00';
  public previousUrl: any;
  public monthNames = [];

  constructor(
    public datePipe: DatePipe,
    public router: Router,
    public timesheetApprovalService: TimesheetApprovalsService,
    public timesheetEntryService: TimesheetEntryService,
    public snackBar: MatSnackBar, public dialog: MatDialog,
    private _location: Location
  ) {
  }

  ngOnInit() {
    this.monthNames = [
      'Jan', 'Feb', 'Mar',
      'Apr', 'May', 'Jun', 'July',
      'Aug', 'Sep', 'Oct',
      'Nov', 'Dec'
    ];
    this.data = this.timesheetApprovalService.getSelectedRowData();
    if (!!this.data) {
      this.selectedrowdetails = this.data.data;
    }
    if (this.selectedrowdetails) {
      const currentDAY = new Date();
      this.currentDate = new Date().getDate();
      if (!!this.data.year) {
        this.currentYear = this.data.year;
      } else {
        this.currentYear = new Date().getFullYear();
      }
      this.getWeekDays(currentDAY);
      this.currentWeek = this.data.weekNumber;
      this.getEmpoyeeTimesheet(this.data.weekNumber);
    } else {
      this.router.navigate(['rm/timeSheetApprovals']);
    }
  }

  /**function to navigate back to previous page */
  backtoTimesheetList() {
    this._location.back();
  }

  /**function to set month and weeks days */
  getWeekDays(currentDate) {
    this.dateDisplay = [];
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const curr = new Date(currentDate);
    let first;
    if (this.config.businessUnit === 'accenture') {
      first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    } else {
      first = curr.getDate() - curr.getDay() + 1; // First day is the day of the month - the day of the week
    }
    this.firstDay = new Date(curr.setDate(first)).toUTCString();
    const startDate = new Date(this.firstDay);
    this.lastDay = new Date(startDate.setDate(startDate.getDate() + 6));
    this.firstDayDate = this.getStartDateWeek(this.data.weekNumber, this.data.year);
    this.lastDayDate = this.getEndDateWeek(this.data.weekNumber, this.data.year);
    this.weekNumer = this.datePipe.transform(startDate, 'ww');
    if (this.config.businessUnit !== 'accenture') {
      this.weekNumer = (this.weekNumer - 1).toString();
    }
    /*Get all the 7 days date in the current week with respective flags */
    for (let i = 0; i < 7; i++) {
      this.getDateDay(i);
    }
    if (this.weekNumer != this.data.weekNumber) {
      if (this.weekNumer < this.data.weekNumber) {
        this.getNextWeek();
      } else {
        this.getPriviousWeek();
      }
    }
  }

  /**function to get date and day */
  getDateDay(number) {
    const getDate = new DateDisplay();
    let days;
    if (this.config.businessUnit === 'accenture') {
      days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    } else {
      days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    }
    getDate.day = days[number];
    const date = new Date(this.firstDay);
    date.setDate(date.getDate() + number);
    if (date.getTime() > new Date().getTime()) {
      getDate.flag = false;
    }
    getDate.date = date.getDate();
    this.dateDisplay.push(getDate);
  }

  /**function to set previous week content*/
  getPriviousWeek() {
    const date = new Date(this.firstDay);
    date.setDate(new Date(this.firstDay).getDate() - 3);
    this.getWeekDays(date);
  }

  /**function to set next week content */
  getNextWeek() {
    const date = new Date(this.lastDay);
    date.setDate(new Date(this.lastDay).getDate() + 1);
    this.getWeekDays(date);
  }

  /**function to get employee timesheet*/
  getEmpoyeeTimesheet(currentWeek) {
    this.timesheetEntryService.getEmployeeProjectDetailsUser(currentWeek, this.selectedrowdetails.employeenumber,
      this.currentYear).subscribe(
        (data) => {
          this.userDetails = data.payload.userDetails;
          this.status = data.payload.approvalStatus;
          if (this.config.businessUnit === 'ipdo' || this.config.businessUnit === 'biologics' || this.config.businessUnit === 'chinateam' || this.config.businessUnit === 'aps') {
            this.dayTotal = new Array(7).fill('00:00');
          }
          const totalTimesheetData = new Array(7).fill(0);
          if (data.payload.projectDetails.length > 0) {
            data.payload.projectDetails.forEach(value => {
              this.projects.push(new ProjectDetails(value, this.status.status, '', '', this.config.businessUnit));
            });

            if (this.config.businessUnit === 'ipdo' || this.config.businessUnit === 'biologics' || this.config.businessUnit === 'chinateam' || this.config.businessUnit === 'aps') {
              for (let p = 0; p < this.projects.length; p++) {
                for (let t = 0; t < this.projects[p].task.length; t++) {
                  for (let i = 0; i < 7; i++) {
                    totalTimesheetData[i] += this.convertHoursToMins(this.projects[p].task[t].WeakDetails[i].FilledHrs);
                    this.dayTotal[i] = this.convertMinsToHrsMins(totalTimesheetData[i]);
                  }
                }
              }
              let weekTotalData = 0;
              for (let x = 0; x < this.dayTotal.length; x++) {
                weekTotalData += this.convertHoursToMins(this.dayTotal[x]);
                this.weakTotal = this.convertMinsToHrsMins(weekTotalData);
              }
            }
          } else {
            this.projects.push(new ProjectDetails('', '', this.firstDay, '', this.config.businessUnit));
          }
        });
  }

  /**function to approve timesheet based on employee*/
  ApproveClicked() {
    this.timesheetApprovalService.rmTimesheetApprove(this.currentWeek, this.selectedrowdetails, this.currentYear).subscribe(
      (data) => {
        this.snackBar.open('Timesheet approved successfully', 'OK', {
          duration: 5000,
        });
        // this.router.navigate(['rm/timeSheetApprovals'], { queryParams: { shoetimesheetlistflag: true } });
        this.router.navigate(['rm/timeSheetApprovals']);
      }
    );
  }

  /**function to reject timesheet*/
  rejectClicked(rowDetail) {
    const dialogRef = this.dialog.open(RejectionConfirmationDialogComponent, {
      width: '40%',
      disableClose: true
    });
    const instance = dialogRef.componentInstance;
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.rejectionComments = instance.rejectionComments;
        this.timesheetApprovalService.rmTimesheetReject(this.currentWeek, this.currentYear, this.selectedrowdetails.employeenumber, this.rejectionComments).subscribe(
          (data) => {
            this.snackBar.open('Timesheet rejected successfully', 'OK', {
              duration: 5000,
            });
            // this.router.navigate(['rm/timeSheetApprovals'], { queryParams: { shoetimesheetlistflag: true } });
            this.router.navigate(['rm/timeSheetApprovals']);
          });
      }
    });
  }

  /**function to  convert hours to mins*/
  convertHoursToMins(hrs) {
    const a = hrs.split(':');
    const minutes = (+a[0]) * 60 + (+a[1]);
    return minutes;
  }

  /**function to  convert hours to mins*/
  convertMinsToHrsMins(mins) {
    let h = Math.floor(mins / 60);
    let m = mins % 60;
    const hrs = h < 10 ? '0' + h : h;
    const mns = m < 10 ? '0' + m : m;
    return `${hrs}:${mns}`;
  }

  /**function to set start date of the week*/
  getStartDateWeek(w, y) {
    const checkDate = new Date(y, 0, 1 + (w - 1) * 7);
    const dow = checkDate.getDay();
    const weekStart = checkDate;
    if (dow <= 4) {
      weekStart.setDate(checkDate.getDate() - checkDate.getDay() + 0);
    } else {
      weekStart.setDate(checkDate.getDate() + 8 - checkDate.getDay());
    }
    const day = weekStart.getDate();
    const monthIndex = weekStart.getMonth();
    const year = weekStart.getFullYear();
    return day + ' ' + this.monthNames[monthIndex] + ' ' + year;
    // return weekStart.toLocaleDateString();
  }

  /**function to set end date of the week*/
  getEndDateWeek(w, y) {
    const checkDate = new Date(y, 0, 1 + (w - 1) * 7);
    const dow = checkDate.getDay();
    const weekStart = checkDate;
    if (dow <= 4) {
      weekStart.setDate(checkDate.getDate() - checkDate.getDay() + 6);
    } else {
      weekStart.setDate(checkDate.getDate() + 8 - checkDate.getDay());
    }
    const day = weekStart.getDate();
    const monthIndex = weekStart.getMonth();
    const year = weekStart.getFullYear();
    return day + ' ' + this.monthNames[monthIndex] + ' ' + year;
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/timesheet-approvals/pendingtimesheet-details/pendingtimesheet-details.component.ts